// BANNER
export const TITLE = <div>Associate Certification Bootcamp</div>;
export const SUB_TITLE =
  "Get Dynatrace Associate Certified faster with comprehensive bootcamp sessions delivered remotely by a Dynatrace expert.";
export const BOOTCAMP_OPTIONS: String[] = [
  "2 days, 8 hours per day",
  "3 days, 6 + 6 + 4 hours",
  "4 days, 4 hours per day",
];
export const TRAINING_TYPE = "ASSOCIATE";

// INSTRUCTIONS
const step1: { step: String; title: String; subTitle: String } = {
  step: "STEP 1",
  title: "Register",
  subTitle: "Register for an upcoming Associate Certification bootcamp.",
};
const step2: { step: String; title: String; subTitle: String } = {
  step: "STEP 2",
  title: "Attend",
  subTitle: "Attend the bootcamp in full and complete all labs and quizzes.",
};
const step3: { step: String; title: String; subTitle: String } = {
  step: "STEP 3",
  title: "Schedule exam",
  subTitle: "Schedule your certification exam.",
};
const step4: { step: String; title: String; subTitle: String } = {
  step: "STEP 4",
  title: "Complete",
  subTitle: "Take the certification exam after the bootcamp.",
};
export const ALL_STEPS: { step: String; title: String; subTitle: String }[] = [
  step1,
  step2,
  step3,
  step4,
];

//CALENDAR
export const CALENDAR_SUB_TITLE =
  "Check the following schedule to register and join the upcoming live sessions for Associate" +
  " Certification Bootcamp on your most convenient time.";

// Requirements
export const TITLE_NOTES_1 = "Requirements";
export const BODY_NOTES_1 = (
  <div className="ml-2 mt-3">
    ·&nbsp;&nbsp; This training is for technical resources that will use the
    Dynatrace platform.
    <br></br>
    ·&nbsp;&nbsp; Requires an up-to-date browser.
  </div>
);

// Certifications & Achievements
export const TITLE_NOTES = "Certifications & Achievements";
export const BODY_NOTES = (
  <div className="ml-2 mt-3">
    ·&nbsp;&nbsp; Upon completion of this training, you’ll be ready to take and
    pass the Associate Certification exam.
    <br></br>
    <br></br>
    ·&nbsp;&nbsp; Becoming a Dynatrace Certified Associate allows you to:
    <br></br>
    &nbsp;&nbsp;·&nbsp;&nbsp; Validate your Dynatrace knowledge to peers,
    customers, and competitors
    <br></br>
    &nbsp;&nbsp;·&nbsp;&nbsp; Move up in your career path with the certification
    of an industry leader
    <br></br>
    &nbsp;&nbsp;·&nbsp;&nbsp; Get one step closer to becoming Dynatrace
    Professional Certified
    <br></br>
    <br></br>
    ·&nbsp;&nbsp; Dynatrace Associate Certification remains valid for 2 years
    and can be renewed
  </div>
);

// FAQs
export const TITLE_ONE = "Access the Demo environment";
export const TITLE_TWO = "Resources";

export const SUB_TITLE_ONE = (
  <div>
    Access the{" "}
    <a target="_blank" href="https://demo.live.dynatrace.com/">
      Demo environment
    </a>
    , where you can practice your skills
  </div>
);
export const SUB_TITLE_TWO = (
  <div>
    Useful resources that will help you get a headstart for the bootcamp:{" "}
    <a target="_blank" href="https://www.dynatrace.com/trial/resources/">
      Free Trial resources.
    </a>
  </div>
);

// --
